<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow:auto;height: calc(100vh - 179px);">
            <es-org-tree @clickByOrg="queryRosteringPlanList"
                         @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-quyu el-icon--left"></i>排班计划</div>
          <div class="es-op-box">
            <el-input placeholder="请输入员工名称"
                      v-model="queryObj.keyWord"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="() => { this.queryObj.pageNum = 1; loadRosteringPlanList() }">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-select style="float: left;"
                       class="query"
                       size="small"
                       v-model="queryObj.dutyTime"
                       placeholder="请选择计划月份"
                       filterable
                       @change="() => {
                this.queryObj.pageNum = 1
                loadRosteringPlanList()
              }">
              <el-option v-for="item in monthList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right:6px"
                       @click="generatePlan(1)"
                       :loading="saving">生成本月计划</el-button>
            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right:6px"
                       @click="generatePlan(2)">生成下月计划</el-button>
            <es-delete @del="del(1)"
                       style="margin-right:6px"
                       label="删除本月计划"
                       type="button"></es-delete>
            <es-delete @del="del(2)"
                       label="删除下月计划"
                       type="button"></es-delete>
          </div>
          <el-table v-if="!loading"
                    :data="pageData.list"
                    ref="rosteringTypeTable"
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loading">
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             fixed
                             align="center">
            </el-table-column>
            <el-table-column prop="orgName"
                             width="120"
                             fixed
                             label="组织名称">
            </el-table-column>
            <el-table-column prop="accountName"
                             fixed
                             label="人员名称">
            </el-table-column>
            <!-- 动态列 -->
            <template v-if="pageData.list != null && pageData.list.length > 0">
              <el-table-column v-for="(item, index) in pageData.list[0].planList"
                               width="120"
                               align="center"
                               :key="index">
                <template slot="header">
                  <span style="font-size:14px"><b>{{ index + 1 }}</b></span><span>（{{ item.week }}）</span>
                </template>
                <template slot-scope="scope">
                  <!-- -->
                  <div fixed
                       v-if="scope.row.planList[index].rosteringName != '休'"
                       @click="edit_plan(scope.row.planList[index])">
                    <el-badge>{{ scope.row.planList[index].rosteringName }}</el-badge>
                    <el-tag v-if="scope.row.planList[index].leaveState == 1"
                            size="mini"
                            type="danger">假</el-tag>
                    <el-tag v-if="scope.row.planList[index].overState == 1"
                            size="mini">加</el-tag>
                  </div>
                  <div v-else
                       style="color:green"
                       @click="edit_plan(scope.row.planList[index])">
                    休
                    <el-tag v-if="scope.row.planList[index].overState == 1"
                            size="mini">加</el-tag>
                  </div>
                </template>

              </el-table-column>
            </template>
            <!-- <el-table-column label="操作"
                             width="120"
                             fixed="right"
                             align="center">
              <template slot-scope="scope">
                <el-button :underline="false"
                           @click="edit_reborn(scope.row)"
                           size="mini"
                           type="primary">重新生成</el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
                           @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadRosteringPlanList() }">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑区域-->
    <el-dialog :visible.sync="editVisible"
               @closed="() => this.$refs['rosteringPlanForm'].clearValidate()"
               width="550px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑排班计划
      </span>
      <el-form :model="rosteringPlanInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="rosteringPlanForm">
        <el-form-item prop="orgName"
                      label="组织名称">
          <el-input v-model="rosteringPlanInfo.orgName"
                    disabled
                    style="width:250px">
          </el-input>
        </el-form-item>
        <el-form-item prop="accountName"
                      label="人员名称">
          <el-input v-model="rosteringPlanInfo.accountName"
                    style="width:250px"
                    disabled>
          </el-input>
        </el-form-item>
        <el-form-item prop="startTime"
                      label="上班时间">
          <el-date-picker v-model="rosteringPlanInfo.startTime"
                          style="width:250px"
                          format="yyyy-MM-dd HH:mm"
                          value-format="yyyy-MM-dd HH:mm"
                          disabled>
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="endTime"
                      label="下班时间">
          <el-date-picker v-model="rosteringPlanInfo.endTime"
                          style="width:250px"
                          format="yyyy-MM-dd HH:mm"
                          value-format="yyyy-MM-dd HH:mm"
                          disabled>
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="workHours"
                      label="上班时长">
          <span>{{ ((rosteringPlanInfo.workHours + rosteringPlanInfo.overHours * 60 - rosteringPlanInfo.leaveHours * 60)
            / 60).toFixed(2)
          }}</span>
          <!-- <el-input v-model="rosteringPlanInfo.workHours"
                    disabled
                    style="width:280px">
          </el-input> -->
        </el-form-item>
        <el-form-item prop="rosteringId"
                      label="排班类型">
          <el-select ref="rosteringIdSelect"
                     style="width:250px"
                     size="mini"
                     v-model="rosteringPlanInfo.rosteringId"
                     placeholder="请选排班类型"
                     filterable>
            <el-option v-for="item in rosteringTypeAllList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"
                       @click.native="getValue(item)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="leaveStartTime"
                      label="加班开始时间">
          <el-date-picker v-model="rosteringPlanInfo.overStartTime"
                          style="width:160px"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm"
                          format="yyyy-MM-dd HH:mm"
                          @change="changeOverTime()"
                          placeholder="选择加班开始时间">
          </el-date-picker>
          <el-input-number style="width:90px"
                           :disabled="rosteringPlanInfo.overStartTime == null"
                           controls-position="right"
                           v-model="rosteringPlanInfo.overHours"
                           :min="0"
                           :max="24"
                           @change="changeOverHour"
                           placeholder="时长"></el-input-number>
        </el-form-item>
        <el-form-item prop="leaveEndTime"
                      label="加班结束时间">
          <el-date-picker v-model="rosteringPlanInfo.overEndTime"
                          style="width:250px"
                          type="datetime"
                          disabled
                          value-format="yyyy-MM-dd HH:mm"
                          format="yyyy-MM-dd HH:mm"
                          @change="changeLeave()">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="rosteringPlanInfo.rosteringId != 9999"
                      prop="leaveStartTime"
                      label="请假开始时间">
          <el-date-picker v-model="rosteringPlanInfo.leaveStartTime"
                          style="width:160px"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm"
                          format="yyyy-MM-dd HH:mm"
                          @change="changeLeaveTime()"
                          placeholder="选择请假开始时间">
          </el-date-picker>
          <el-input-number style="width:90px"
                           :disabled="rosteringPlanInfo.leaveStartTime == null"
                           controls-position="right"
                           v-model="rosteringPlanInfo.leaveHours"
                           @change="changeLeaveHour()"
                           :min="0"
                           :max="24"
                           placeholder="时长"></el-input-number>
        </el-form-item>
        <el-form-item v-if="rosteringPlanInfo.rosteringId != 9999"
                      prop="leaveEndTime"
                      label="请假结束时间">
          <el-date-picker v-model="rosteringPlanInfo.leaveEndTime"
                          style="width:250px"
                          disabled
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm"
                          format="yyyy-MM-dd HH:mm"
                          placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitRosteringPlan()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'
export default {
  name: 'rosteringplan',
  props: ["funcs"],
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20, dutyTime: dateutils.dateFormat("YYYYmm", new Date()) },//查询条件
      pageData: {},
      orgTree: [],
      value1: [],
      rosteringTypeAllList: [],
      editVisible: false,
      rosteringPlanInfo: {},//区域信息
      monthList: [],
      rules: {//验证条件
      },
      loading: false,
      saving: false
    }
  },
  methods: {
    //页面初始化
    init () {
      this.queryPlanMonthListAll()
      this.loadRosteringPlanList()
      this.listRosteringTypeAll()
    },
    initOrgTree (orgTree) {
      this.orgTree = orgTree
    },
    queryRosteringPlanList (orgIds) {
      this.queryObj.pageNum = 1;
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(",");
      }
      this.loadRosteringPlanList();
    },
    changeOverTime () {
      this.rosteringPlanInfo.overHours = 0;
      this.rosteringPlanInfo.overEndTime = null;
    },
    changeOverHour () {
      console.log("changeOverHour", this.rosteringPlanInfo.overHours)
      if (this.rosteringPlanInfo.overHours > 0) {
        var curTime = new Date(this.rosteringPlanInfo.overStartTime);
        var addHour = curTime.setHours(curTime.getHours() + this.rosteringPlanInfo.overHours);
        console.log(dateutils.dateFormat("YYYY-mm-dd HH:MM", new Date(addHour)))
        this.rosteringPlanInfo.overEndTime = dateutils.dateFormat("YYYY-mm-dd HH:MM", new Date(addHour))
      } else {
        this.rosteringPlanInfo.overEndTime = null;
      }
      // }, 400)
    },
    changeLeaveTime () {
      console.log("changeLeaveTime", this.rosteringPlanInfo.leaveHours)
      this.rosteringPlanInfo.leaveHours = 0;
      this.rosteringPlanInfo.leaveEndTime = null;
      if (this.rosteringPlanInfo.leaveStartTime != null && (this.rosteringPlanInfo.leaveStartTime < this.rosteringPlanInfo.startTime || this.rosteringPlanInfo.leaveStartTime >= this.rosteringPlanInfo.endTime)) {
        this.$message.error("请假开始时间应在工作时间范围之内，请重新选择")
        this.rosteringPlanInfo.leaveStartTime = null;
        return
      }

    },
    changeLeaveHour () {
      console.log("changeLeaveHour", this.rosteringPlanInfo.leaveHours)
      if (this.rosteringPlanInfo.leaveHours > 0) {
        var curTime = new Date(this.rosteringPlanInfo.leaveStartTime);
        var addHour = curTime.setHours(curTime.getHours() + this.rosteringPlanInfo.leaveHours);
        console.log(dateutils.dateFormat("YYYY-mm-dd HH:MM", new Date(addHour)))
        this.rosteringPlanInfo.leaveEndTime = dateutils.dateFormat("YYYY-mm-dd HH:MM", new Date(addHour))
      } else {
        this.rosteringPlanInfo.leaveEndTime = null;
      }
    },
    generatePlan (type) {
      this.saving = true;
      let param = new Object()
      console.log(this.orgTree)
      param.orgIds = this.queryObj.orgIds
      param.type = type
      this.$ajax.get('/buss/rostering/generatePlan', param).then(msg => {
        this.saving = false
        this.$message.success(msg)
      }
      ).catch(err => {
        this.$message.error(err)
        this.saving = false;
      })
    },
    listRosteringTypeAll () {
      this.loading = true
      this.$ajax.get('/buss/rostering/listRosteringTypeAll').then(msg => {
        msg.push({
          "id": 9999,
          "name": "休"
        });
        this.rosteringTypeAllList = msg
        console.log('listRosteringTypeAll', this.rosteringTypeAllList);
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化系统下拉框
    queryPlanMonthListAll () {
      this.$ajax.get('/buss/rostering/listRosteringPlanMonth').then((msg) => {
        this.monthList = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },
    //获取线路名称
    getValue (row) {
      console.log('getValue', row);
      this.rosteringPlanInfo.rosteringName = row.name;
      if (row.id != 9999) {
        console.log('getValue', row.name);
        this.rosteringPlanInfo.startTime = row.startTime;
        this.rosteringPlanInfo.endTime = row.endTime;
        this.rosteringPlanInfo.workHours = row.workHours;
        this.rosteringPlanInfo.state = 1;
      } else {
        console.log('getValue', row.name);
        this.rosteringPlanInfo.startTime = null;
        this.rosteringPlanInfo.endTime = null;
        this.rosteringPlanInfo.workHours = 0;
        this.rosteringPlanInfo.state = 0;
      }
      this.rosteringPlanInfo.overHours = 0;
      this.rosteringPlanInfo.overStartTime = null;
      this.rosteringPlanInfo.overEndTime = null;
      this.rosteringPlanInfo.leaveHours = 0;
      this.rosteringPlanInfo.leaveStartTime = null;
      this.rosteringPlanInfo.leaveEndTime = null;
      this.$refs['rosteringPlanForm'].clearValidate();
    },
    //从后台查询区域列表
    loadRosteringPlanList () {
      this.loading = true
      this.$ajax.get('/buss/rostering/listRosteringPlan', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化添加区域
    add_init () {
      this.editVisible = true
      this.rosteringPlanInfo = {}
    },
    edit_plan (rowPlan) {
      console.log('edit_plan', rowPlan);
      this.rosteringPlanInfo = JSON.parse(JSON.stringify(rowPlan))
      this.rosteringPlanInfo.workHours = this.rosteringPlanInfo.workHours + this.rosteringPlanInfo.leaveHours * 60 - this.rosteringPlanInfo.overHours * 60
      this.editVisible = true
    },
    edit_reborn (row) {
      this.loading = true;
      this.$ajax.get('/buss/rostering/generatePlan', { "accountId": row.accountId, "month": this.queryObj.dutyTime }).then(msg => {
        this.pageData = msg
        this.loading = false;
        this.loadRosteringPlanList();
      }).catch(err => {
        this.$message.error(err)
        this.loading = false;
      })
    },
    //初始化编辑区域
    edit_init (row) {
      this.editVisible = true
      this.rosteringPlanInfo = JSON.parse(JSON.stringify(row))
    },
    //保存区域信息
    submitRosteringPlan () {
      this.$refs["rosteringPlanForm"].validate(valid => {
        if (valid) {
          let url = "/buss/rostering/editRosteringPlan";
          this.saving = true
          this.rosteringPlanInfo.workHours = this.rosteringPlanInfo.workHours + this.rosteringPlanInfo.overHours * 60 - this.rosteringPlanInfo.leaveHours * 60
          if (this.rosteringPlanInfo.workHours > 0) {
            this.rosteringPlanInfo.state = 1
          } else {
            this.rosteringPlanInfo.state = 0
          }
          if (this.rosteringPlanInfo.overHours > 0) {
            this.rosteringPlanInfo.overState = 1
          } else {
            this.rosteringPlanInfo.overState = 0
          }
          if (this.rosteringPlanInfo.leaveHours > 0) {
            this.rosteringPlanInfo.leaveState = 1
          } else {
            this.rosteringPlanInfo.leaveState = 0
          }
          this.$ajax.post(url, this.rosteringPlanInfo).then(msg => {
            this.saving = false
            this.loadRosteringPlanList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除区域信息
    del (type) {
      this.loading = true
      let param = new Object()
      param.orgIds = this.queryObj.orgIds
      param.type = type
      this.$ajax.post('/buss/rostering/deleteRosteringPlan', param).then(msg => {
        this.loading = false
        this.$message.success(msg)
        this.queryObj.pageNum = 1//删除之后，回到第一页
        this.loadRosteringPlanList()
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.item {
  margin-top: 1px;
  margin-right: 1px;
}
</style>
